'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const QRCodeCanvas = dynamic(() => import('qrcode.react')?.then((m) => m?.QRCodeCanvas), { ssr: false });

export default function QRCodeDisplay() {
  return (
    <div className="flex flex-col items-center">
      <div className="bg-card rounded-3xl p-6 card-shadow-lg w-full flex flex-col items-center">
        <p className="text-muted-foreground text-sm font-medium mb-1">Kasaya Gösterin</p>
        <h2 className="text-foreground font-bold text-lg mb-4">QR Kod ile Öde</h2>

        {/* QR Code */}
        <div className="bg-white p-4 rounded-2xl border-4 border-primary/20 mb-4">
          <QRCodeCanvas
            value="starbucks://pay?card=1234&user=ayse_kaya&token=mock_token_abc123"
            size={200}
            fgColor="#1E3932"
            bgColor="#FFFFFF"
            level="H"
          />
        </div>

        {/* Card info */}
        <div className="flex items-center gap-2 bg-muted rounded-xl px-4 py-2 mb-4">
          <span className="text-muted-foreground text-xs font-mono">**** **** 1234</span>
          <span className="text-border">·</span>
          <span className="text-muted-foreground text-xs">₺245,50 bakiye</span>
        </div>

        {/* Refresh hint */}
        <p className="text-muted-foreground text-xs text-center">
          QR kod 60 saniyede bir yenilenir
        </p>
      </div>

      {/* Security note */}
      <div className="mt-4 bg-accent/50 rounded-xl p-3 flex items-start gap-2 w-full">
        <span className="text-primary text-lg">🔒</span>
        <p className="text-foreground text-xs leading-relaxed">
          Ödeme güvenli SSL şifrelemesi ile korunmaktadır. QR kodunuzu yalnızca Gloria Jeans kasalarında gösterin.
        </p>
      </div>
    </div>
  );
}